(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["wss-rating"] && !Shopify.designMode) return;
  try {
    (function () {
    function go(t, smooth) {
      var still = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
      t.scrollIntoView({ behavior: smooth && !still ? 'smooth' : 'instant', block: 'start' });
      if (!t.hasAttribute('tabindex')) t.setAttribute('tabindex', '-1');
      try { t.focus({ preventScroll: true }); } catch (e) {}
    }
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a.wss-rating[href="#reviews"]');
      if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var t = document.getElementById('reviews');
      if (!t) return;
      e.preventDefault();
      go(t, true);
    });
    if (location.hash === '#reviews') {
      var drop = function () {
        var t = document.getElementById('reviews');
        if (t) go(t, false);
        try { history.replaceState(history.state, '', location.pathname + location.search); } catch (e) {}
      };
      if (document.readyState === 'complete') setTimeout(drop, 300); else window.addEventListener('load', function () { setTimeout(drop, 300); });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
